module.exports = __webpack_public_path__ + "img/proses_stidest.e60d74bb.svg";